<template>
  <div id="app">
      <div class="container">
          <router-view/>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  created() {
    if (this.sig === null) {
      this.setSig(this.genId(20));
    }
    window.addEventListener('message', (event) => {
      if (event.data.key === `madForm-${this.$route.params.id}`) {
        if (!this.$store.getters.cookieAccepted) {
          this.$store.commit('addM360Cookie', event.data.cookie);
          this.$store.commit('acceptM360Cookie');
        }
      }
    });
  },
  methods: {
    ...mapMutations({
      setSig: 'setSig',
    }),
    genId(len) {
      var arr = new Uint8Array((len || 40) / 2);
      self.crypto.getRandomValues(arr);
      var dec2hex = function (dec) {
        return dec.toString(16).padStart(2, '0');
      };
      return Array.from(arr, dec2hex).join('');
    }
  },
  computed: {
    ...mapGetters({
      sig: 'sig'
    })
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body.transparent-bg .text-muted {
  color: #6c757d !important;
}
</style>
